import { ActivePickems } from "components/Pickem/PickemOptions/ActivePickems";
import { UpcomingPickems } from "components/Pickem/PickemOptions/UpcomingPickems";
import { GlobalPickemLeaderboard } from "components/Pickem/Leaderboard/GlobalPickemLeaderboard";
import { CompactRecentMatches } from "components/Matches/Compact/CompactRecentMatches";
import { CompactUpcomingMatches } from "components/Matches/Compact/CompactUpcomingMatches";
import { Column, GrowColumn } from "pages/styles";
import { COMPACT_COL_WIDTH } from "theme";
import { PickemGroups } from "components/Pickem/Groups/PickemGroups";
import { Panel } from "components/Panel/Panel";
import { MultiColumnPage } from "pages/PageTemplates";

const RECENT_MATCHES_AMOUNT = 8;
const UPCOMING_MATCHES_AMOUNT = 8;

export const PickemPage = () => {
  return (
    <MultiColumnPage>
      <Column
        style={{ minWidth: COMPACT_COL_WIDTH, maxWidth: COMPACT_COL_WIDTH }}
        hideUnderWidth={850}
      >
        <Panel header="Upcoming Matches">
          <CompactUpcomingMatches amount={UPCOMING_MATCHES_AMOUNT} />
        </Panel>
      </Column>
      <GrowColumn>
        <Panel header="Groups">
          <PickemGroups />
        </Panel>
        <Panel header="Active Pick'ems">
          <ActivePickems />
        </Panel>
        <Panel header="Upcoming Pick'ems">
          <UpcomingPickems />
        </Panel>
        <GlobalPickemLeaderboard />
      </GrowColumn>
      <Column
        style={{ minWidth: COMPACT_COL_WIDTH, maxWidth: COMPACT_COL_WIDTH }}
        hideUnderWidth={1100}
      >
        <Panel header="Recent Matches">
          <CompactRecentMatches amount={RECENT_MATCHES_AMOUNT} />
        </Panel>
      </Column>
    </MultiColumnPage>
  );
};
